import { Backdrop, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { API } from "../conf";
import { Context } from "../App";

export default function EgliseReset(props) {
    const {updateConnect} = useContext(Context)
    const [logs, setLogs] = useState(false);
    const [loading, setLoading] = useState(false);

    function handleReset() {
        setLoading(true);
        fetch(API.concat(`/eglises/reset/${logs}`), {method: 'PATCH',headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({eglises: props.eglises.map(e=>e.number)})
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                setLoading(false)
                props.showResult(response.status === 200)
                props.close()
            }
        })
    }

    return(
        <Box display="flex" flexDirection="column" sx={{paddingInline:2, paddingBottom:3}}>
            <Typography variant="h5" align="center" marginBottom={2}>Réinitialiser la base de données</Typography>
            <Typography variant="h6" >Églises concernées: </Typography>
            <ul style={{marginBottom:'5px'}}>
                {props.eglises.map((e, i) => <li key={i}>{e.nom}</li>)}
            </ul>
            <Typography variant="body1" sx={{marginBottom:'20px'}}>
                Cette action va supprimer toutes les données d'écriture de la base de données :
                <ul>
                    <li>Dons</li>
                    <li>Dépenses</li>
                    <li>Versements</li>
                    <li>Comptes (hors compte d'initialisation tel que liaison, petite-caisse, etc. et les comptes bancaires)</li>
                    <FormControlLabel control={<Checkbox checked={logs} onChange={()=>setLogs(old=>!old)} />} label="journaux" />
                </ul>
                Cette action est irréversible et ne peut pas être annulée.<br/>
                Voulez-vous vraiment continuer ?
            </Typography>

            <Stack direction="row" spacing={2} alignSelf='flex-end'>
                <Button variant="contained" color="error" onClick={handleReset}>Réinitialiser</Button>
                <Button variant="outlined" color="primary" onClick={props.close} sx={{marginLeft:'20px'}}>Annuler</Button>
            </Stack>

            <Backdrop open={loading}><CircularProgress/></Backdrop>
        </Box>
    )
}